import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import {  useState } from 'react';
import AuthenticationEndpoint from '../../../api/endpoint/AuthenticationEndpoint';
import { useNavigate, useLocation } from "react-router";
import { useSession } from '../../context/SessionContext';


export const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [validated, setValidated] = useState(false);
    const [message, setMessage] = useState('');

    const navigate = useNavigate();
    const location = useLocation();
    // Parse redirect param from query string
    const params = new URLSearchParams(location.search);
    const redirect = params.get("redirect");

    const {refreshSession} = useSession();

    const handleSubmit = (event: any) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else if(form.checkValidity() === true) {
            event.preventDefault();
            handleLogin();
        }

        setValidated(true);
    };

    const handleLogin = async() => {
        try{
            console.log('[Login] Attempting login for:', username);
            const loginResult = await AuthenticationEndpoint.Login(username, password);
            console.log('[Login] Login result:', loginResult);
            
            if(loginResult.data && loginResult.data.success) {
                console.log('[Login] Login successful, refreshing session...');
                // F-06: Fix race-prone navigation - refresh session BEFORE navigating
                // This ensures the session state is updated before the component unmounts
                await refreshSession();
                
                console.log('[Login] Session refreshed, navigating...');
                // Now navigate after session is refreshed
                const destination = redirect ? redirect : '/';
                setTimeout(() => navigate(destination, { state: { key: Date.now() } }), 0);
            } else {
                console.error('[Login] Login failed:', loginResult);
                setMessage('Login failed: ' + (loginResult.errors?.[0]?.message || 'Unknown error'));
            }

        } catch(err) {
            console.error('Login error: ' + (err instanceof Error ? err.message : String(err)));
            setMessage('Login error: ' + (err instanceof Error ? err.message : String(err)));
        }
    };



    return (
        <Card style={{margin:'10% 25%'}}>
            <Card.Body>
                <Card.Title>Login</Card.Title>
                <Card.Subtitle className="my-2">
                    <strong>This login is for admins only. No login needed for course registration.</strong>
                </Card.Subtitle>
                <Card.Body>
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <Form.Group>
                            <Form.Label>Username</Form.Label>
                            <Form.Control required value={username} onChange={(e) => setUsername(e.target.value)} type="text"/>
                            <Form.Control.Feedback type="invalid">Please enter a username.</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control required value={password} onChange={(e) => setPassword(e.target.value)} type="password"/>
                            <Form.Control.Feedback type="invalid">Please enter a password.</Form.Control.Feedback>
                        </Form.Group>
                        <div className="d-flex gap-3 align-items-center">
                            <Button type="submit" className="text-light">Log In</Button>
                            <div className="text-danger">{message}</div>
                        </div>
                        
                    </Form>
                </Card.Body>
                
            </Card.Body>
            
        </Card>
    )
}